import cookie from "cookie";

const useCookie = () => {
  const defaultOptions = {
    secure: process.env.NODE_ENV === "production",
  };

  const setCookie = (name, value, options = {}) => {
    if (typeof window !== "undefined") {
      const combinedOptions = { ...defaultOptions, ...options };
      document.cookie = cookie.serialize(name, value, combinedOptions);
    }
  };

  const getCookie = (name) => {
    if (typeof window === "undefined" || !name) {
      return undefined;
    }

    const cookies = cookie.parse(document.cookie);
    return cookies[name];
  };

  const removeCookie = (name, options = {}) => {
    const combinedOptions = { ...defaultOptions, ...options };
    setCookie(name, "", { ...combinedOptions, maxAge: -1 });
  };

  return {
    setCookie,
    getCookie,
    removeCookie,
  };
};

export default useCookie;
